/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Status_Athlete_DoingInputs */

const fr_session_status_athlete_doing = /** @type {(inputs: Session_Status_Athlete_DoingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

/**

* @param {Session_Status_Athlete_DoingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const session_status_athlete_doing = /** @type {((inputs?: Session_Status_Athlete_DoingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Status_Athlete_DoingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_session_status_athlete_doing(inputs)
});